define('formkit/view/block/design.form.object.collection.view',['require','exports','module','underscore','../form.object/form.object.collections.by.section.collection.view','../form.object/form.object.collection.view','../form.object/design.form.object.view','../../behavior/template.object.reorder.drag.drop.behavior','../../behavior/form.object.menu.drag.drop.behavior'],function(require, exports, module) {
  var _                                            = require('underscore');
  var FormObjectCollectionsBySectionCollectionView = require('../form.object/form.object.collections.by.section.collection.view');
  var FormObjectCollectionView                     = require('../form.object/form.object.collection.view');
  var DesignFormObjectView                         = require('../form.object/design.form.object.view');
  var TemplateObjectReorderDragDropBehavior        = require('../../behavior/template.object.reorder.drag.drop.behavior');
  var FormObjectMenuDragDropBehavior               = require('../../behavior/form.object.menu.drag.drop.behavior');


  var DesignFormObjectCollectionBlockView = FormObjectCollectionsBySectionCollectionView.extend({

    options: _.extend({}, FormObjectCollectionsBySectionCollectionView.prototype.options, {
      designable: true
    }),

    childView: FormObjectCollectionView.extend({
      behaviors: _.extend({}, FormObjectCollectionView.prototype.behaviors, {
        TemplateObjectReorderDragDropBehavior: {
          behaviorClass: TemplateObjectReorderDragDropBehavior,
          useDragHandler: true,
          dragHandle: '.ui.drag-handle'
        },
        FormObjectMenuDragDropBehavior: {
          isContainer: true,
          behaviorClass: FormObjectMenuDragDropBehavior
        }
      }),
      childView: DesignFormObjectView
    }),

    initialize: function() {
      FormObjectCollectionsBySectionCollectionView.prototype.initialize.apply(this, arguments);

      if (this.form) {
        this.collection = this.form.getTemplateModel().get('children');
      }
    },
  });
  module.exports = DesignFormObjectCollectionBlockView;
});

